import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocCustomRolesRoute: InvariantJiraRoute = {
	name: 'eoc-custom-roles',
	path: '/jira/settings/products/ops/roles',
	exact: true,
};
